export {};

window.API_URL = "http://localhost:7108";

// If we need to register a new domain to this reCAPTCHA visit https://www.google.com/recaptcha/admin/site/714729420/settings
// Below is a test key only for localhost
window.RECAPTCHA_SITE_KEY = "6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI";
window.API_URL = "https://api.v13full.qa.kana.earth";
window.RECAPTCHA_SITE_KEY = "6Lcf0JkqAAAAAEqbBk1Y9NbXjRInllN_flDRa_Io";
